import { render, staticRenderFns } from "./CloudIntroduce.vue?vue&type=template&id=0cc5f2fa&scoped=true&"
import script from "./CloudIntroduce.vue?vue&type=script&lang=ts&"
export * from "./CloudIntroduce.vue?vue&type=script&lang=ts&"
import style0 from "./CloudIntroduce.vue?vue&type=style&index=0&id=0cc5f2fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc5f2fa",
  null
  
)

export default component.exports